import { Dialog, InputCheckbox } from 'ui';
import Upload from 'core/modules/components/Upload/Upload';
import React from 'react';
import CropImageFile from './CropImageFile';
import useCropImage from './useCropImage';

type CropImageProps = {
  hasImage?: boolean;
  isAvatar?: boolean;
  isCalculateDimensions?: boolean;
  onChange?: (data: string) => void;
  onChangeFile?: (file: File | undefined) => void;
  setImage?: (data: string) => void;
  subTitle?: string;
  title?: string;
  titleDialogCrop?: string;
  url?: string;
};

function CropImage({
  hasImage,
  isAvatar = false,
  isCalculateDimensions = false,
  onChange = () => {},
  onChangeFile = () => {},
  setImage = () => {},
  subTitle = '',
  title = '',
  titleDialogCrop = '',
  url = '',
}: CropImageProps): JSX.Element {
  const { file, image, open, isOriginalImage, getFile, onCancel, onChangeImage, onCheckOriginal, onOpenDialog, onSuccess, t } = useCropImage({
    onChange,
    onChangeFile,
    setImage,
  });

  return (
    <>
      <Upload
        accept="image"
        file={file}
        getFile={getFile}
        hasImage={hasImage}
        isVisibleImg
        onChange={onOpenDialog}
        subTitle={subTitle}
        title={title}
        url={url}
      />

      <Dialog
        buttonTextSuccess={t('actions:Confirm')}
        onClose={onCancel}
        onSuccess={onSuccess}
        isOpen={open}
        size={isOriginalImage ? 'xl' : 's'}
        title={titleDialogCrop || title}
      >
        {isOriginalImage ? (
          <div className="crop-image__original">
            <img src={image} alt="Original" />
          </div>
        ) : (
          <CropImageFile file={file} isAvatar={isAvatar} isCalculateDimensions={isCalculateDimensions} onChange={onChangeImage} />
        )}

        <div className="d-flex align-items-center mt-3">
          <InputCheckbox checked={isOriginalImage} onChange={onCheckOriginal} label={t('common:Image original')} />
        </div>
      </Dialog>
    </>
  );
}

export default CropImage;
